import { AmbientLight } from "three";
import { DirectionalLight } from "three";
import { Scene } from "three";
import { Menu } from "../../components/menus/Menu";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { ModalControler } from "../../components/modals/ModalControler";
import { ZoneModalInfo } from "../../components/modals/ZoneInfoModal";
import { MouseEvents } from "../controls/mouseEvents";
import { GltfAngelopolis } from "../objects/GltfAngelopolis";
import hdr from "../../assets/models/IndustrialRoom_HDRI.hdr";
import { PMREMGenerator } from "three";
import { LinearToneMapping } from "three";
import { GltfIcons } from "../objects/GltfIcons";
import { ModalInfoAmenidades } from "../../components/modals/ModalInfoAmenidades";
import { InstrucctionsModal } from "../../components/modals/InstrucctionsModal";
import { GltfMapa } from "../objects/GltfMapa";
import { GlbCalles } from "../objects/GlbCalles";
import { ModalLotes } from "../../components/modals/LotesModal";
import { GlbNumeracion } from "../objects/GltfNumeracion";
import { GUI } from "dat.gui";

export class MainScene extends Scene {
  constructor(container, renderer, camera, loadingManager, control) {
    super();
    this.loadingManager = loadingManager;
    this.container = container;
    this.control = control;
    this.lastMesh = null;
    this.renderer = renderer;
    this.camera = camera;
    // this.background = new Color("#fdb4bf")
    this.rombosInput = document.querySelector("#rombosInput");
    this.switchArrows = document.querySelector("#switchArrows");
    this.loader = new RGBELoader();
    this.loader.load(hdr, (texture) => {
      const pmremGenerator = new PMREMGenerator(this.renderer);
      var envMap = pmremGenerator.fromEquirectangular(texture).texture;

      this.environment = envMap;
      texture.dispose();
      pmremGenerator.dispose();
    });
    this.renderer.toneMapping = LinearToneMapping;
    this.renderer.toneMappingExposure = 1.4;
    // const gui =  new GUI();
    //     const cameraControls = gui.addFolder("hdr")
    //     cameraControls.add(this.renderer, "toneMappingExposure",0,10).step(0.1).listen()
    //     cameraControls.open()
    // this.fog = new Fog( 0x282828, 10, 50 );
    // this.helper();

    this.addElementsInScene();
    this.mouseControls();
    this.light();
    this.initUiListteners();
    this.renderAnimations();
    this.modalLotes = new ModalLotes(this);
    this.menu = new Menu(
      this.camera,
      this.iconsgltf,
      this.directional,
      this.gltf,
      this.control,
      this.gltfMaps
    );
    this.modalterrain = new ModalControler();
    this.modalZoneInfo = new ZoneModalInfo();
    this.instrucctionsModal = new InstrucctionsModal(this.camera);
    this.modalAmenidades = new ModalInfoAmenidades();
  }

  helper() {
    const gui = new GUI();
    const cameraControls = gui.addFolder("camera");
    cameraControls
      .add(this.camera.position, "x", -300, 300)
      .step(0.001)
      .listen();
    cameraControls
      .add(this.camera.position, "y", -1000, 1000)
      .step(0.001)
      .listen();
    cameraControls
      .add(this.camera.position, "z", -900, 100)
      .step(0.001)
      .listen();
    cameraControls
      .add(this.camera.rotation, "x", -5.0, 5.0)
      .step(0.001)
      .listen();
    cameraControls
      .add(this.camera.rotation, "y", -5.0, 5.0)
      .step(0.001)
      .listen();
    cameraControls
      .add(this.camera.rotation, "z", -5.0, 5.0)
      .step(0.001)
      .listen();
    cameraControls.open();
    const controls = gui.addFolder("controls");
    controls.add(this.control.target, "x", -300, 300).step(0.01).listen();
    controls.add(this.control.target, "y", -700, 700).step(0.01).listen();
    controls.add(this.control.target, "z", -300, 300).step(0.01).listen();
    controls.open();
  }
  addElementsInScene() {
    this.add(this.camera);
    this.calles = new GlbCalles(this.loadingManager);
    this.numeration = new GlbNumeracion(this.loadingManager);
    this.gltf = new GltfAngelopolis(this.loadingManager);
    this.iconsgltf = new GltfIcons(this.loadingManager);
    this.gltfMaps = new GltfMapa(this.loadingManager);
    // this.gltfmodalClosuter = new GltfModalClouster()
    // this.ground = new Ground()
    this.add(
      this.gltf,
      this.iconsgltf,
      this.gltfMaps,
      this.calles,
      this.numeration
    );
  }
  light() {
    this.ambient = new AmbientLight(0xffffff, 0.15);
    this.directional = new DirectionalLight(0xffffff, 2);
    // e2e2e2
    this.directional.position.set(12, 77.36, 8);
    this.add(this.ambient, this.directional);
    // const helper = new DirectionalLightHelper( this.directional, 5 );
    // this.add( helper );

    //
    // const data = {
    //     color: this.ambient.color.getHex(),
    //     mapsEnabled: true
    // }
    // const gui =  new GUI();
    // const ligthControls = gui.addFolder("Ambient ligth")
    // ligthControls.addColor(data, 'color').onChange(() => {
    //     this.ambient.color.setHex(Number(data.color.toString().replace('#', '0x')))
    // })
    // ligthControls.add(this.ambient, 'intensity', 0, 1, 0.01)

    // const data2 = {
    //     color: this.directional.color.getHex(),
    //     mapsEnabled: true
    // }
    // const lightFolder = gui.addFolder('directional light')
    // lightFolder.addColor(data2, 'color').onChange(() => {
    //     this.directional.color.setHex(Number(data2.color.toString().replace('#', '0x')))
    // })
    // lightFolder.add(this.directional, 'intensity', 0, 2, 0.01).listen()
    // lightFolder.add(this.directional.position, "x", -100, 100, 0.01).listen()
    // lightFolder.add(this.directional.position, "y", -100, 100, 0.01).listen()
    // lightFolder.add(this.directional.position, "z", -100, 100, 0.01).listen()
    // lightFolder.open()
  }
  mouseControls() {
    this.mouseEvents = new MouseEvents(
      this.container,
      this.renderer,
      this.camera,
      this
    );

    this.mouseEvents.onPoinertMove((intersects) => {
      if (this.menu.topCamera) {
        if (this.menu.leveCamera === 0) {
          const objectFinded = this._isHoverZoneGeneral(intersects);
          if (objectFinded.length > 0) {
            this.gltf.hoverZones(objectFinded[0].object.name, this.menu);
          } else {
            this.gltf.hoverZones("", this.menu);
          }
        } else {
          const objectClouster = this._isHoverClousters(intersects);
          if (objectClouster.length > 0) {
            // this.gltfmodalClosuter.position.set(objectClouster[0].point.x,objectClouster[0].point.y+20,objectClouster[0].point.z+10)
            this.gltf.hoverClousters(objectClouster[0].object.name, this.menu);
          } else {
            this.gltf.hoverClousters("", this.menu);
          }
        }
        if (
          intersects.length > 0 &&
          intersects[0].object.name.substring(0, 2) === "I_"
        ) {
          if (intersects[0].object != this.lastMesh) {
            if (this.lastMesh) {
              this.lastMesh.scale.set(1, 1, 1);
              // this.lastMesh.material.color = new Color("#ffffff")
            }
            this.lastMesh = intersects[0].object;
            this.menu.leveCamera === 0
              ? this.lastMesh.scale.set(1.5, 1.5, 1.5)
              : this.lastMesh.scale.set(1.1, 1.1, 1.1);
            // this.lastMesh.material.color = new Color("#88dd22")
          }
        } else {
          if (this.lastMesh) {
            this.lastMesh.scale.set(1, 1, 1);
            // this.lastMesh.material.color = new Color("#ffffff")
          }
          this.lastMesh = null;
        }
      } else {
        let lote = this._isHoverLote(intersects);
        if (
          intersects.length > 2 &&
          intersects[1].object.name.substring(0, 2) === "I_"
        ) {
          lote = [intersects[1]];
        }
        if (lote.length > 0) {
          if (lote[0].object != this.lastMesh) {
            if (this.lastMesh) {
              this.lastMesh.scale.set(1, 1, 1);
              // this.lastMesh.material.color = new Color("#ffffff")
            }
            this.lastMesh = lote[0].object;
            this.lastMesh.name.substring(0, 2) === "I_"
              ? this.lastMesh.scale.set(1.4, 1.4, 1.4)
              : this.lastMesh.scale.set(1.2, 1.2, 1.2);
            // this.lastMesh.material.color = new Color("#88dd22")
          }
        } else {
          if (this.lastMesh) {
            this.lastMesh.scale.set(1, 1, 1);
            // this.lastMesh.material.color = new Color("#ffffff")
          }
          this.lastMesh = null;
        }
      }
    });
    this.mouseEvents.onPointerUp((intersects) => {
      console.log(intersects);
      if (
        intersects.length > 0 &&
        intersects[0].object.name.substring(0, 2) === "I_"
      ) {
        this.modalAmenidades.showModal(intersects[0].object.name);
      }
      if (
        intersects.length > 2 &&
        intersects[1].object.name.substring(0, 2) === "I_"
      ) {
        this.modalAmenidades.showModal(intersects[1].object.name);
      } else {
        if (this.menu.topCamera) {
          if (this.menu.leveCamera === 0) {
            const objectFinded = this._isHoverZoneGeneral(intersects);
            if (objectFinded.length > 0) {
              this.gltf.hoverZones("", this.menu);
              this.menu.clickZones(objectFinded[0].object.name);
            }
          } else {
            const objectClouster = this._isHoverClousters(intersects);
            if (objectClouster.length > 0) {
              this.gltf.hoverClousters("", this.menu);
              this.menu.clickClouster(objectClouster[0].object.name);
            }
          }
        } else {
          const lote = this._isHoverLote(intersects);
          if (lote.length > 0) {
            // console.log(lote[0].object.name);
            const LoteFinded = lote[0].object;
            this.modalterrain.showModal(LoteFinded.name);
          }
        }
      }
    });
  }

  initUiListteners() {
    this.rombosInput.addEventListener("click", (e) => {
      console.log(this.rombosInput.checked);
      if (this.rombosInput.checked) {
        this.gltf.showRombos();
      } else {
        this.gltf.hideRombos();
      }
    });
    this.switchArrows.addEventListener("click", (e) => {
      if (this.switchArrows.checked) {
        this.iconsgltf.showArrows();
      } else {
        this.iconsgltf.hiddenArrows();
      }
    });
  }
  _isHoverZoneGeneral(intersects) {
    return intersects.filter(
      (intersect) =>
        intersect.object.name === "Terreno_cascatta2_MT_G_terreno_0" ||
        intersect.object.name === "Terreno_cascatta" ||
        intersect.object.name === "Terreno_cascatta_MT_G_terreno_0" ||
        intersect.object.name === "Sin_lotes_MT_G_terreno_0" ||
        intersect.object.name === "Zona_Azul_MT_G_terreno_0" ||
        intersect.object.name === "Lomas2_MT_G_terreno_0" ||
        intersect.object.name === "Lomas1_MT_G_terreno_0" ||
        intersect.object.name === "Terreno_nuevaZona_MT_G_terreno_0" ||
        intersect.object.name === "Terreno_nuevaZona2_MT_G_terreno_0" ||
        intersect.object.name === "Distrito_escolar_MT_G_terreno_0001" ||
        intersect.object.name === "Terreno_parques_MT_G_terreno_0" ||
        intersect.object.name === "Terreno_nuevaZona_3"
    );
  }
  _isHoverClousters(intersects) {
    return intersects.filter(
      (intersect) =>
        intersect.object.name === "Banqueta_fontana_MT_G_terreno_0" ||
        intersect.object.name ===
          "Banqueta_fontana_MT_G_cityLomas_banqueta_0" ||
        intersect.object.name === "Banqueta_sacramento_MT_G_terreno_0" ||
        intersect.object.name ===
          "Banqueta_sacramento_MT_G_cityLomas_banqueta_0" ||
        intersect.object.name === "Banqueta_arcadia_MT_G_terreno_0" ||
        intersect.object.name === "Galena4" ||
        intersect.object.name ===
          "Banqueta_arcadia_MT_G_cityLomas_banqueta_0" ||
        intersect.object.name === "Banqueta_rinconada_MT_G_terreno_0" ||
        intersect.object.name ===
          "Banqueta_rinconada_MT_G_cityLomas_banqueta_0" ||
        intersect.object.name === "Banqueta_capri_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_capri_MT_G_cityLomas2_banqueta_0" ||
        intersect.object.name === "Banqueta_Creta_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_Creta_MT_G_cityLomas2_banqueta_0" ||
        intersect.object.name === "Banqueta_rodas_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_rodas_MT_G_cityLomas2_banqueta_0" ||
        intersect.object.name === "Banqueta_bali_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_vilansa_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_vilansa_MT_G_Vilansa_0" ||
        intersect.object.name === "Banqueta_parqueViena_MT_G_terreno_0" ||
        intersect.object.name ===
          "Banqueta_parqueViena_MT_G_zonaAzul_banqueta_0" ||
        intersect.object.name === "Banqueta_parqueBerna_MT_G_terreno_0" ||
        intersect.object.name ===
          "Banqueta_parqueBerna_MT_G_zonaAzul_banqueta_0" ||
        intersect.object.name === "Banqueta_sofia_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_sofia_MT_G_zonaAzul_banqueta_0" ||
        intersect.object.name === "Banqueta_palermo_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_palermo_MT_G_zonaAzul_banqueta_0" ||
        intersect.object.name === "Banqueta_anturio_MT_G_terreno_0" ||
        intersect.object.name === "Banqueta_lucerna" ||
        intersect.object.name === "Banqueta_lacantera" ||
        intersect.object.name === "Banqueta_balcanes" ||
        intersect.object.name === "Banqueta_antalya" ||
        intersect.object.name === "Banqueta_niza" ||
        intersect.object.name === "Banqueta_verona" ||
        intersect.object.name === "Banqueta_sorrento" ||
        intersect.object.name === "Banqueta_trento" ||
        intersect.object.name === "Banqueta_zante" ||
        intersect.object.name === "Banqueta_Ferrara" ||
        intersect.object.name === "Banqueta_Siena" ||
        intersect.object.name === "Banqueta_Montenegro" ||
        intersect.object.name === "Banqueta_TerraVerde" ||
        intersect.object.name === "Banqueta_Milos" ||
        intersect.object.name === "Banqueta_anturio_MT_G_Anturio_0"
    );
  }
  _isHoverLote(intersects) {
    // return intersects.filter(
    //   (intersec) =>
    //     intersec.object.name.substring(0, 3) === "CAL" ||
    //     intersec.object.name.substring(0, 3) === "VIC" ||
    //     intersec.object.name.substring(0, 3) === "CER"
    // );
    if (
      intersects.length >= 5 &&
      intersects[2].object.name.substring(0, 3) !== "Ban" &&
      intersects[2].object.name.substring(0, 9) !== "Mesh351_1" &&
      intersects[2].object.name.substring(0, 7) !== "Mesh351" &&
      intersects[2].object.name.substring(0, 3) !== "Outl" &&
      intersects[2].object.name.substring(0, 4) !== "Vial" &&
      intersects[2].object.name.substring(0, 4) !== "Hove" &&
      intersects[2].object.name.substring(0, 4) !== "Casa" &&
      intersects[2].object.name.substring(0, 4) !== "Case" &&
      intersects[2].object.name.substring(0, 4) !== "Tree" &&
      intersects[2].object.name.substring(0, 4) !== "Arbo" &&
      intersects[2].object.name.substring(0, 4) !== "Past" &&
      intersects[2].object.name.substring(0, 4) !== "Gale" &&
      intersects[2].object.name.substring(0, 3) !== "Are"
    ) {
      return [intersects[2]];
    } else {
      return [];
    }
  }

  renderAnimations() {
    this.gltf.renderAnimations();
    this.iconsgltf.renderAnimations();
  }
}
